<template>
    <div class='container'>
        <div class='row'>
            <div class='col-12'>
                <v-form
                    ref='form'
                    v-model='valid'
                    lazy-validation
                    @submit.prevent='createPersonnel()'
                >
                    <v-container>
                        <v-row>
                            <v-col cols='12'>
                                <h3 class='d-block font-weight-bold flex-grow-1 mb-4 mt-3'>ثبت نام ماهرین</h3>
                                <info-alert>
                                    <ul class="pl-0 pr-4">
                                        <li>فرایند فعال سازی حساب ماهرین پس از ثبت درخواست اولیه الزام به تکمیل اطلاعات هویتی، معرفی حساب بانکی، انجام مصاحبه و آزمون تاییدیه مهارت میباشد</li>
                                    </ul>
                                    <template slot='action'>
                                        <v-btn
                                            small
                                            color='primary'
                                            outlined
                                            :to="{name:'EditUser'}"
                                        >
                                            تکمیل اطلاعات هویتی
                                        </v-btn>
                                    </template>
                                </info-alert>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols='12' sm="6">
                                <v-select
                                    v-model='model.marketSubjects'
                                    :items='marketSubjectOptions'
                                    :rules='rules.marketSubjects'
                                    required
                                    item-text='title'
                                    multiple
                                    item-value='_id'
                                    label='دسته بندی شفل'
                                ></v-select>
                            </v-col>
                            <v-col cols='12' sm="6">
                                <v-text-field
                                    v-model='model.jobTitle'
                                    :rules='rules.jobTitle'
                                    required
                                    label='عنوان شغل'
                                >
                                </v-text-field>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols='12' md='6'>
                                <v-btn
                                    name='submit'
                                    :loading='loading'
                                    :disabled='!valid ||loading'
                                    color='primary'
                                    type='submit'
                                    @click='validate'
                                >ثبت
                                </v-btn>
                                <v-btn
                                    class='mr-2'
                                    outlined
                                    @click='goBack'
                                >
                                    انصراف
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import InfoAlert from '@/components/Alerts/InfoAlert';
import {mapActions} from 'vuex';

export default {
    name: 'Form',
    components: {InfoAlert},
    data() {
        return {
            errorDialog: false,
            error: null,
            valid: false,
            marketSubjectOptions: [],
            loading: true,
            model: {},
            rules: {
                marketSubjects: [
                    v => !!v || 'لطفا یک گزینه انتخاب کنید',
                    v => v.length > 0 ? true : 'لطفا یک گزینه انتخاب کنید'
                ],
                jobTitle: [
                    v => !!v || 'عنوان شغل اجباری میباشد'
                ]
            }
        };
    },
    methods: {
        goBack() {
            this.$store.commit('goBack');
            this.$router.replace(this.$store.state.history.page);
        },
        validate() {
            this.$refs.form.validate();
        },
        async createPersonnel() {
            this.loading = true;
            let data = {
                model: this.model
            };

            await axios.post(`/api/personnel`,
                data)
                .then(() => {
                    let message = 'اطلاعات شما بروزرسانی شد.';
                    this.$snackbar.showMessage({content: message, color: 'success'});
                }).catch((error) => {
                    console.log(error);
                    let message = 'اطلاعات شما ثبت نشد.';
                    this.$snackbar.showMessage({content: message, color: 'red'});
                    this.error = error.response;
                    this.errorDialog = true;
                });
            this.loading = false;

        },
        async fetchPersonnel() {
            this.loading = true;

            await axios.get(`/api/personnel`)
                .then(res => {
                    this.model = res.data.personnel;
                }).catch((error) => {
                    console.log(error);
                    let message = 'دریافت اطلاعات با مشکل مواجه شد ';
                    this.$snackbar.showMessage({content: message, color: 'red'});
                    this.$error.showError(error.response);
                });
            this.loading = false;

        },
        async fetchMarketSubjects() {
            await axios
                .get('/api/marketSubjects')
                .then(res => {
                    this.marketSubjectOptions = res.data.marketSubjects;
                    if (this.model.marketSubjects) {
                        this.marketSubjectOptions.forEach(item => {
                            if (item._id === this.model.marketSubjects) {
                                this.model.marketSubjects.push(item);
                            }
                        });
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.user.account = {};
                    this.loading = false;
                });
        },
        ...mapActions(['showBreadCrumbs', 'setBreadCrumbsTemp'])
    },
    async created() {
        await this.fetchPersonnel();
        await this.fetchMarketSubjects();
        let href = window.location.pathname + window.location.search;
        await this.setBreadCrumbsTemp({
            key: 'personnelForm',
            value: {
                text: `ثبت‌نام ماهرین`,
                href: href
            }
        });
    },
    async updated() {
        await this.showBreadCrumbs(['personnelForm']);
    }

};
</script>

<style scoped>

</style>